<template>
  <gw-listing class="a7-classificacao-indicador-listing" :refresh="refresh"
    :title="$t('ClassificacaoIndicador')"
    :default-filter-params="defaultFilterParams" modal-size="small"
    :entity-dto-rest-resource="entityDTORestResource"
    :presentation="presentation"
  >
  <gw-column field="caminho"/>
  <gw-column field="tipo"/>

  <template slot="filterBand">
    <gw-text-filter-item :display-text="$t('ClassificacaoIndicador.ui.filtroCaminho')"
      property-name="caminho"/>
    <gw-possible-value-filter-item :display-text="$t('ClassificacaoIndicador.ui.filtroTipo')"
      property-name="tipo"
      :possibleValues="tipoPossibleValues"/>
    <gw-boolean-filter-item :display-text="$t('ClassificacaoIndicador.ui.filtroFolha')"
      property-name="folha"
      :trueText="$t('ClassificacaoIndicador.ui.filtroFolha.sim')"
      :falseText="$t('ClassificacaoIndicador.ui.filtroFolha.nao')"/>
  </template>

  <template slot="editor" slot-scope="{ entity }">
    <gw-grouping-pane :title="$t('Global.ui.detalhes')">
      <gw-grid-container>
        <div class="gw-row">
          <gw-editor-field property="nome" class="gw-col-6"/>
          <gw-editor-field property="tipo" class="gw-col-6"/>
        </div>
        <div class="gw-row">
          <gw-editor-field property="classificacaoIndicadorPai" class="gw-col-6">
            <a7-classificacao-indicador-entity-chooser slot-scope="{ entity, properties }"
            v-model="entity.classificacaoIndicadorPai"
            v-bind="properties"
            :disabled="tipoNaoEspecificado(entity)"
            :tipo="entity && entity.tipo"
            />
          </gw-editor-field>
          <gw-editor-field class="gw-col-6"
            :presentationProperties="codigoA7PresentationProperties" >
            <gw-text-field class="codigoA7" disabled :value="codigoA7(entity)"/>
          </gw-editor-field>
        </div>
      </gw-grid-container>
      </gw-grouping-pane>
  </template>

  </gw-listing>
</template>

<script>
import {
  GwListing,
  GwTextField,
  GwTextFilterItem,
  GwBooleanFilterItem,
  GwPossibleValueFilterItem,
  GwColumn,
  GwEditorField,
  GwGroupingPane,
  GwGridContainer,
  FilterUtilities
} from "guaxinim-web";
import ClassificacaoIndicadorRestResource from './ClassificacaoIndicadorRestResource'
import A7ClassificacaoIndicadorEntityChooser from './A7ClassificacaoIndicadorEntityChooser'
import ClassificacaoIndicadorConstants from './ClassificacaoIndicadorConstants'

export default {
  name: "a7-classificacao-indicador-listing",
  components: {
    GwListing,
    GwTextField,
    GwTextFilterItem,
    GwPossibleValueFilterItem,
    GwBooleanFilterItem,
    GwColumn,
    GwEditorField,
    GwGroupingPane,
    GwGridContainer,
    A7ClassificacaoIndicadorEntityChooser
  },
  props: {
    defaultFilterParams: {
      type: Object
    }
  },
  data() {
    return {
      entityDTORestResource: ClassificacaoIndicadorRestResource,
      presentation: null,
      entityPresentation: null,
      codigoA7PresentationProperties: {
        description : {
          key : 'ClassificacaoIndicador.ui.codigoA7'
        }
      }
    }
  },
  computed: {
    tipoPossibleValues() {
      if (!this.entityPresentation) return [];
      return this.entityPresentation.properties.tipo.possibleValues;
    }
  },
  methods: {
    refresh(filterParams) {
      return this.entityDTORestResource.findDTOs(null,
        FilterUtilities.createFilterParamsString(filterParams));
    },
    codigoA7(entity) {
      if (!entity || !entity.codigoA7) {
        return null;
      }

      return entity.codigoA7.toString();
    },
    tipoNaoEspecificado(entity) {
      return entity && entity.tipo === ClassificacaoIndicadorConstants.TIPO_NAO_ESPECIFICADO
    }
  },
  created() {
    this.entityDTORestResource.getDtoPresentation()
      .then(presentation => this.presentation = presentation)
      .catch((err) => this.$gw.defaultExceptionHandler.handleUnknowException(err, this));
    this.entityDTORestResource.getPresentation()
      .then(presentation => this.entityPresentation = presentation)
      .catch((err) => this.$gw.defaultExceptionHandler.handleUnknowException(err, this));
  }
};
</script>

<style lang="scss" scoped>
</style>
